<template>
  <el-dialog title="编辑设备"
             :visible.sync="showModal"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="modalInfo"
               :rules="modalRules"
               ref="modalForm"
               label-width="100px"
               class="modal-form">
        <!-- 
        <el-form-item label="设备名称："
                      prop="name">
          <el-input v-model.trim="modalInfo.name"
                    placeholder="请输入设备名称"></el-input>
        </el-form-item>
        -->
        <el-form-item label="所属区域："
                      prop="area_id">
          <el-select v-model="modalInfo.area_id"
                     placeholder="请选择所属区域"
                     @change="areaChange">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属房间:"
                      prop="room_id">
          <el-select v-model="modalInfo.room_id"
                     placeholder="请选择所属房间">
            <el-option v-for="item in roomList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注："
                      prop="remarks">
          <el-input type="textarea"
                    v-model.trim="modalInfo.remarks"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/gate/edit'"
                 type="primary"
                 @click="handleConfirm('modalForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      modalInfo: {
        id: 0,
        // name: '',
        activated: 1,
        area_id: '',
        room_id: '',
        remarks: ''
      },
      modalRules: {
        // name: [{ required: true, message: '请输入设备名称' }],
        area_id: [{ required: true, message: '请选择所属区域' }],
        room_id: [{ required: true, message: '请选择所属房间' }]
      },
      areaList: [],
      roomList: [],
      tmpArr: []
    }
  },
  created() {
    this.getList()
    this.getInfo()
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getFacilitieInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.modalInfo.id = data.id
            this.modalInfo.area_id = data.area_id
            this.modalInfo.room_id = data.room_id
            this.modalInfo.remarks = data.remarks
            this.getRoom(data.area_id)
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取数据
    getList() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch.editFacilitie({ ...this.modalInfo }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.handleCancel('refresh')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    },
    // 切换楼宇时获取房间
    areaChange(val) {
      this.modalInfo.room_id = ''
      this.getRoom(val)
    },
    // 获取房间
    getRoom(id) {
      fetch.getRoomList({ area_id: id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roomList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    }
  }
}
</script>

<style></style>
